//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.ShipDesign.LimitBoxBuilder.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../no/SelectBody.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[0,"DefaultBlockName",1,0],[0,"IncludeEntireBody",1,0],[0,"IntersectedElementsConfigApplyToAll",1,0],[0,"IntersectedStiffenersCreateCutouts",1,0],[0,"IntersectedStiffenersCreateSketchCurves",1,0],[0,"IntersectionLinesApplyLineFeatures",1,0],[0,"IntersectionLinesCreateSketchCurves",1,0],[1,"LimitBox",0,"Features.ShipDesign.LimitBoxBuilder",0],[0,"NameStructuralElement",1,0],[0,"PreviousPlane",0,"NXObject",0],[1,"ShipName",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"SourceBody",0,"SelectBody",0],[0,"SourcePlane",1,"DatumPlane",0],[0,"Type",1,0],[0,"UpdateStructuralElement",1,0],[0,"UpdateStructuralElementOnLoad",1,0]],[],[]];
SPLM.Features.ShipDesign.StructuralElementBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StructuralElementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StructuralElementBuilder.Types = Object.freeze({
    "Plane" : "Plane", "GeneralSurface" : "GeneralSurface"});

export default SPLM;